import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { NavLink } from "react-router-dom";

function SideBarItem({ item }: any) {
  if (item?.SUBNAV?.length > 0 && item?.DIRECT === undefined) {
    return (
      <li className="theredrop">
        <input
          type="checkbox"
          style={{ display: "none" }}
          id={`childbox-${item?.KEY}-${item?.SUBNAV?.length}`}
        />
        <label htmlFor={`childbox-${item?.KEY}-${item?.SUBNAV?.length}`}>
          <div className="nav_link">
            <div className="nav_item">
              <div className="nav_item_in">
                {item?.ICON && <item.ICON />}
                <div className="tile">{item?.TITLE}</div>
              </div>
              <div className="drop_icon open_drop">
                <ArrowDropDownIcon />
              </div>
            </div>
          </div>
        </label>
        <ul className={`child_item child-${item?.SUBNAV?.length}`}>
          {item?.SUBNAV?.map((SUBITEM: any, j: number) => (
            <li key={j}>
              <NavLink
                to={`${SUBITEM?.PATH}`}
                className={({ isActive }) =>
                  isActive ? "nav_link nav_link_active" : "nav_link"
                }
              >
                <div className="nav_item">
                  <div className="tile">{SUBITEM?.TITLE}</div>
                </div>
              </NavLink>
            </li>
          ))}
        </ul>
      </li>
    );
  } else if (item?.SUBNAV?.length === 0 && item?.ELEMENT === undefined) {
    return null;
  } else {
    return (
      <li className="nodrop">
        <NavLink
          to={item?.PATH}
          className={({ isActive }) =>
            isActive ? "nav_link nav_link_active" : "nav_link"
          }
        >
          <div className="nav_item">
            {item?.ICON && <item.ICON />}
            <div className="tile">{item?.TITLE}</div>
          </div>
        </NavLink>
      </li>
    );
  }
}

export default SideBarItem;
